import * as L from 'leaflet';

import { Location } from './location';
import { LeafletMapSettings } from './leaflet-map-settings';
import { TileServerSettings } from './tile-server-settings';

export class LeafletMap {
    map: L.Map;
    markers: Map<string, L.Marker>;

    constructor(private id: string, private settings: LeafletMapSettings, private tileServerSettings: TileServerSettings) {
        this.map = null;
        this.map = L.map(this.id, this.settings.mapOptions);
        this.addLayer();
        this.markers = new Map<string, L.Marker>();
    }

    addLayer() {
        L.tileLayer(this.tileServerSettings.urlTemplate, this.tileServerSettings.urlParameters).addTo(this.map);
    }

    addMarker(location: Location, icon: L.Icon, message?: string): void {
        const boundingBox: L.LatLngBounds = this.map.getBounds();
        if (boundingBox.contains(location.latLng)) {

            const options: L.MarkerOptions = {
                icon: icon
            };

            const marker = L.marker(location.latLng, options);

            const popup = L.popup({
                className: 'popup-custom',
                autoPan: false
            }).setContent(message || location.description);

            marker.addTo(this.map)
                .bindPopup(popup)
                .on('mouseover', e => e.target.openPopup())
                .on('mouseout', e => e.target.closePopup())
                .on('click', e => {
                    e['location'] = location;
                    this.map.fireEvent('markerClick', e);
                });
            this.markers.set(location.id, marker);
        }
    }

    zoomOut(): void {
        this.map.zoomOut();
    }

    getCenter(): L.LatLng {
        return this.map.getCenter();
    }

    getZoom(): number {
        return this.map.getZoom();
    }

    on(event: string, fn: L.LeafletEventHandlerFn): void {
        this.map.on(event, fn);
    }

    onInit(id: string, options: L.MapOptions): void {
        this.map = L.map(id, options);
    }

    setView(center: L.LatLngExpression, zoom: number, options?: L.ZoomPanOptions): void {
        this.map.setView(center, zoom, options);
        this.addLayer();
    }

    showPopup(id: string): void {
        const marker = this.markers.get(id);
        if (marker) {
            marker.openPopup();
        }
    }
}



// WEBPACK FOOTER //
// D:/a/29/s/PDMI.PharmacyLocator.Web/src/lib/maps/leaflet-map.ts